import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'filterByFunc'})
export class FilteByFuncPipe implements PipeTransform
{
    transform(data: any[], searchText: string, func: (item: any, query: string) => boolean): any[]
    {
        if(!searchText || !func) {
            return data;
        }
        if (!Array.isArray(data)) {
            return [];
        }
        return data.filter((item) => func(item, searchText));
    }
}
